export default function () {
  return {
    disconnects: [],
    disconnectsCurrentPage: 1,
    disconnectsLastPage: 1,
    disconnectsPerPage: 0,
    disconnectsTotal: 0,
    disconnectsLoading: false,
    indexPage: null
  }
}
